import React, {Component} from "react";
import PropTypes from 'prop-types';
import {XDiv, XI, XSpan} from "../Layout/Layout";
import getChilds from "../Children/Children";
import ReactDOM from "react-dom";
import Escape from "../Event/Escape";
import PScrollbar from "../Scrollbar/PScrollbar";

const otherRoot = document.getElementById('other-root');

var modalZIndex=1040;
var modalListDrop=[];

class  Modal extends Component{

    constructor(props) {
        super(props);

        this.isBackDrop=props.isBackDrop;
        this.width=props.width;

        this.Hclose = this.close.bind(this);

        this.headerChilds=getChilds(props.children,"header");
        this.bodyChilds=getChilds(props.children,"body");
        this.footerChilds=getChilds(props.children,"footer");

        this.state = {show:false,active:true};

        this.element=React.createRef();
        this.elBackdrop=React.createRef();
        this.dialogEl=React.createRef();
        this.body=React.createRef();

        this.Hclose=this.close.bind(this);

        this.ps1 = null;
        this.isAlive = true;
        this.isInit=false;
        this.props=props;
    }

    setBody(Childs){
        this.bodyChilds=Childs;
        this.forceUpdate();
        if(this.ps1) this.ps1.refresh();
    }


    click(evt) {
        if(this.state.show){
            this.hide();
        }else{
            this.show();
        }
        evt.preventDefault();
        evt.stopPropagation();
        return false;
    }

    enabled() {
        this.setState({active: true});
    }

    disabled() {
        this.setState({active: false});
    }

    async open() {
        if(this.state.active) {
            if(!this.props.isFullScreen) this.elBackdrop.current.style.zIndex=modalZIndex;
            modalZIndex++;
            this.element.current.style.zIndex=modalZIndex;
            modalZIndex++;
            if(!this.props.isFullScreen) modalListDrop.push(this.elBackdrop.current);
            let o=100/modalListDrop.length;
            for (let i=0;i<modalListDrop.length;i++){
                modalListDrop[i].style.opacity = o/100.0;
                modalListDrop[i].style.filter = "alpha(opacity="+o+")"; //For IE;
            }
            if(this.isBackDrop){
                if(!document.body.classList.contains('modal-open'))
                document.body.classList.add('modal-open');
            }
            await this.setState({show: true});
            setTimeout(function() {
                if(!this.props.isFullScreen) this.elBackdrop.current.classList.add("noAnimation");
                if(this.isAlive)  if(this.ps1) { this.ps1.refresh();   }
            }.bind(this), 550);
            this.element.current.focus();
            setTimeout(function() {
                if(this.isAlive)   if(this.ps1) { this.ps1.refresh();   }
            }.bind(this), 1000);
        }
    }

    close() {
        if(this.state.active) {
            this.element.current.classList.add('closing');
            let f = this.props.closeCallback;
            if (f !== null) {
                if (f instanceof Function) {
                    f();
                }
            }
            if(!this.props.isFullScreen)
            if (this.elBackdrop.current.classList.contains("noAnimation")) {
                this.elBackdrop.current.classList.remove("noAnimation");
            }
            setTimeout(function() {
                this.setState({show: false});
            }.bind(this), 550);
            if(modalListDrop.length>0){
                modalListDrop.pop();
                let o=100/modalListDrop.length;
                for (let i=0;i<modalListDrop.length;i++){
                    modalListDrop[i].style.opacity = o/100.0;
                    modalListDrop[i].style.filter = "alpha(opacity="+o+")"; //For IE;
                }
            }else{
                document.body.classList.remove('modal-open');
            }
        }
    }

    noAnimation(){
        if (this.md !== null) {
            if (this.dialogEl.current.classList.contains("noAnimation")) {
                this.dialogEl.current.classList.remove("noAnimation");
            }
        }
    }

    componentDidMount() {
        if(this.isInit===false){
            this.isInit=true;
        }
        Escape.set(this.element.current,this.Hclose);

        if(this.props.hasScrollbar){
            this.ps1 = new PScrollbar(this.body.current,{option:{suppressScrollX: true,scrollXMarginOffset: 10,scrollYMarginOffset: 10 }});
        }
    }

    renderPortal() {
        const {
            isFullScreen
        } = this.props;
        if(isFullScreen) return null;
        let c="modal-backdrop fade";
        if(this.state.show) c="modal-backdrop fade show" ;
        return <XDiv  eleRef={this.elBackdrop} className={c} />;
    }

    renderPortalModal() {
        const {
            className,
            dialogClass,
            hasClose,
            hasScrollbar,
            isFullScreen
        } = this.props;

        let c=`modal fade  ${className}`;
        if(this.state.show) c=`modal fade show ${className}`;
        let cd=`modal-dialog `;
        if(isFullScreen){ cd=cd+" modal-dialog-full-width";}
        cd=cd+" "+dialogClass;
        if(hasScrollbar){ cd=cd+" modal-dialog-scrollable";}



        let header=null;

        let mh1="modal-header";
        if(isFullScreen){ mh1=mh1+" modal-header-full-width";}


        if(this.headerChilds.length>0) {
            if(hasClose){
                header= <XDiv className={mh1}> {this.headerChilds}
                    <XSpan className="close closeModal" onClick={this.Hclose}><XI className="la la-times" /></XSpan>
                </XDiv>;
            }else{
                header= <XDiv className={mh1}> {this.headerChilds}  </XDiv>;
            }
        }else{
            if(hasClose){
                header= <XDiv className='modal-header'>
                    <XSpan className="close closeModal" onClick={this.Hclose}><XI className="la la-times" /></XSpan>
                </XDiv>;
            }
        }

        let body=null;
        if(this.bodyChilds.length>0) {
            body = <XDiv className='modal-body  psGray' eleRef={this.body}>  {this.bodyChilds} </XDiv>;
        }
        let footer=null;
        if(this.footerChilds.length>0) footer=<XDiv className='modal-footer'> {this.footerChilds} </XDiv>;

        let mc1="modal-content";
        if(isFullScreen){ mc1=mc1+" modal-content-full-width";}

        return <XDiv eleRef={this.element} className={c}>
            <XDiv eleRef={this.dialogEl}  className={cd}>
                <XDiv className={mc1}>
                    {header}
                    {body}
                    {footer}
                </XDiv>
            </XDiv>
        </XDiv>;
    };

    render() {
        return (
            <React.Fragment>
                {ReactDOM.createPortal(this.renderPortalModal(), otherRoot)}
                {ReactDOM.createPortal(this.renderPortal(), otherRoot)}
            </React.Fragment>
        )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }
        Escape.unBind(this.element.current);
        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }

}


Modal.propTypes = {
    className: PropTypes.string,
    dialogClass: PropTypes.string,
    isBackDrop: PropTypes.bool,
    width: PropTypes.number,
    closeMode: PropTypes.PropTypes.oneOf(['btnClick', 'windowClick']),
    closeCallback: PropTypes.func,
    hasClose:PropTypes.bool,
    hasScrollbar:PropTypes.bool,
    isFullScreen:PropTypes.bool,
};

Modal.defaultProps = {
    className:"",
    dialogClass:"modal-dialog-centered ",
    isBackDrop:true,
    width:0,
    closeMode:"btnClick",
    closeCallback:null,
    hasClose:true,
    hasScrollbar:false,
    isFullScreen:false,
};

export default Modal ;
